<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <h5 class="mb-1 text-white">
            {{ $route.params.id ? "Edit document" : "Create document" }}
          </h5>
        </b-card-title>

        <b-link :to="{ name: 'documents' }">
          <span>back to the document list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm" #default="{ invalid }">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col lg="6">
                <!-- <b-col class="d-flex" lg="12">
                  <b-form-group
                    label-for="content"
                    class="w-100"
                    label="Content"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="content"
                      rules="required"
                    >
                      <b-form-file
                        v-model="content"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col> -->

                <b-col class="d-flex" lg="12">
                  <b-form-group label-for="type" class="w-100" label="Type">
                    <validation-provider
                      #default="{ errors }"
                      name="Type"
                      rules="required"
                    >
                      <select-box
                        v-model="type"
                        label="text"
                        class="w-100"
                        select="value"
                        searchable
                        :lists="[
                          { text: 'Zip', value: 'ZIP' },
                          { text: 'Id card front', value: 'ID_CARD_FRONT' },
                          { text: 'Id card back', value: 'ID_CARD_BACK' },
                          { text: 'portrait', value: 'PORTRAIT' },
                        ]"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="isAdmin">
                  <b-form-group label-for="status" class="w-100" label="Status">
                    <validation-provider
                      #default="{ errors }"
                      name="Status"
                      rules="required"
                    >
                      <select-box
                        v-model="status"
                        label="name"
                        :lists="statuses"
                        class="w-100"
                        select="val"
                        searchable
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="isAdmin">
                  <b-form-group
                    label-for="model_type"
                    class="w-100"
                    label="Model type"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Model type"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="model_type"
                        :options="['partner', 'user']"
                        class="d-flex align-items-center my-1"
                        name="radio-inline"
                        :disabled="$route.params.id ? true : false"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="isAdmin">
                  <b-form-group
                    label-for="model_id"
                    class="w-100"
                    label="Model"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Model id"
                      rules="required"
                    >
                      <select-box
                        v-model="model_id"
                        label="text"
                        class="w-100"
                        :url="model_type"
                        select="id"
                        searchable
                        :disabled="$route.params.id ? true : false"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-form-group
                  label-for="reason"
                  class="col-md-8 col-12 pr-0 pl-md-1 pl-0"
                  label="Reason"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Reason"
                    rules="required"
                  >
                    <b-form-textarea
                      id="reason"
                      v-model="reason"
                      name="reason"
                      :state="errors.length > 0 ? false : null"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group> -->
              </b-col>
              <b-col
                class="d-flex flex-column justify-content-around px-2 pb-2"
                lg="6"
                v-if="type"
              >
                <div v-if="type != 'ZIP'" class="d-flex align-items-center">
                  <b-img
                    v-if="imageUrl || imageContentPreview"
                    ref="previewEl"
                    :src="imageUrl || imageContentPreview || errorImage"
                    rounded
                    class="p-25"
                    @error="setAltImg"
                    fluid
                  />

                  <feather-icon v-else icon="ImageIcon" size="50" />
                </div>
                <div ref="previewEl" style="width: 100%" rounded v-else>
                  <feather-icon icon="FileIcon" size="50" />
                  <b-link class="p-1" :href="zipUrl || zipContentPreview">{{
                    zipUrl || zipContentPreview ? "Your document" : "empty"
                  }}</b-link>
                </div>
                <small
                  class="pt-50 text-danger"
                  v-if="type == 'ZIP' ? !zipContent : !imageContent"
                  >The content field is required</small
                >
                <div class="d-flex flex-wrap mt-2">
                  <b-button
                    class="gradient-btn px-75"
                    @click="$refs.refInputEl.click()"
                  >
                    <input
                      @input="changeContent"
                      ref="refInputEl"
                      type="file"
                      class="d-none"
                      :accept="type == 'ZIP' ? '.zip' : 'image/*'"
                    />
                    <span class="d-none d-sm-inline">Upload</span>
                    <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
                  </b-button>
                  <b-button
                    class="ml-50 px-75"
                    @click="removeContent"
                    :disabled="type == 'ZIP' ? !zipContent : !imageContent"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                class="gradient-btn"
                type="submit"
                :disabled="
                  invalid || (type == 'ZIP' ? !zipContent : !imageContent)
                "
              >
                submit
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BFormTextarea,
  BAvatar,
  BImg,
  BFormRadioGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    Loader,
    SelectBox,
    BFormTextarea,
    BAvatar,
    BImg,
    BFormRadioGroup,
  },
  data() {
    return {
      zipContent: "",
      imageContent: "",
      zipUrl: "",
      zipContentPreview: "",
      imageUrl: "",
      imageContentPreview: "",
      type: "",
      model_type: "",
      model_id: "",
      model: "",
      status: "",

      statuses: [
        {
          val: "PENDING",
          name: "pending",
        },
        {
          val: "ACCEPTED",
          name: "accept",
        },
        {
          val: "REJECTED",
          name: "reject",
        },
      ],
      reason: "",
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getDocument();
    }
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    isAdmin() {
      return this.userData.type == "admin";
    },
  },
  methods: {
    changeContent(e) {
      if (this.type == "ZIP") {
        this.zipContent = e.target.files[0];
        this.zipContentPreview = URL.createObjectURL(e.target.files[0]);
      } else {
        this.imageContent = e.target.files[0];
        this.imageContentPreview = URL.createObjectURL(e.target.files[0]);
      }
    },
    removeContent() {
      if (this.type == "ZIP") {
        this.zipContent = "";
        this.zipContentPreview = "";
        this.zipUrl = "";
      } else {
        this.imageContent = "";
        this.imageContentPreview = "";
        this.imageUrl = "";
      }
    },
    async getDocument() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/documents/${this.$route.params.id}`
        );
        await Object.keys(data.data).map((item) => {
          if (item === "url") {
            if (data.data.type == "ZIP") {
              this.zipContent = data.data[item];
              this.zipUrl = data.data[item];
            } else {
              this.imageContent = data.data[item];
              this.imageUrl = data.data[item];
            }
          } else if (item.includes("model")) {
            this.model = data.data.model.data;
            this.model_type = data.data.model_type;
            setTimeout(() => {
              this.model_id = data.data.model_id;
            }, 500);
          } else {
            this[item] = data.data[item];
          }
        });
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = {};
            if (this.$route.params.id) {
              newObject = await {
                content:
                  this.type == "ZIP" ? this.zipContent : this.imageContent,
                type: this.type,
                status: this.status,
              };
            } else {
              if (this.isAdmin) {
                newObject = await {
                  type: this.type,
                  content:
                    this.type == "ZIP" ? this.zipContent : this.imageContent,
                  model_type: this.model_type,
                  model_id: this.model_id,
                  status: this.status,
                  reason: this.reason,
                };
              } else {
                newObject = await {
                  type: this.type,
                  content:
                    this.type == "ZIP" ? this.zipContent : this.imageContent,
                  status: this.status,
                };
              }
            }
            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });
            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/documents/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getDocument();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Document Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "/panel/documents",
                this.formData
              );
            }
            this.$router.push({ name: "documents" });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
